__turbopack_context__.v({
  "column": "grid-module__3RYvIW__column",
  "fullRow": "grid-module__3RYvIW__fullRow",
  "heroSliderContainer": "grid-module__3RYvIW__heroSliderContainer",
});
